<template>
  <div v-show="videoLive">
    <div class="modal-header">
      <button type="button" class="close" @click.prevent="close">
        <i class="icon-cross"></i>
      </button>
    </div>
    <div class="modal-body">
      <web-cam :select-first-device="true" @video-live="show" @cameras="cameraListLoaded" @camera-change="cameraChanged"
               ref="webCam" height="100%"/>
      <a href="javascript:void(0)" class="take-picture" @click.prevent="capture">
        <span class="take-picture__inner-circle"></span></a>

      <a href="javascript:void(0)" class="switch-camera" v-if="availableCameras.length > 1" @click.prevent="selectNextCamera">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#30AB7A" fill-rule="evenodd" d="M7.67323754,3.00001777 C7.39394932,3.00663368 7.15868664,3.20434725 7.11238794,3.47116667 C7.06685084,3.73871994 7.22319202,3.99964976 7.48503128,4.09373277 L8.63861306,4.5229771 C5.90343423,5.71813241 4,8.38470837 4,11.4734536 C4,15.1669645 6.67902976,18.3018104 10.3022966,18.9884282 L10.3022966,18.9891639 C10.4548433,19.0185639 10.6134674,18.9876925 10.7424742,18.9031664 C10.8714811,18.8186385 10.9602899,18.6885443 10.9898799,18.5400625 C11.0187199,18.392322 10.9853258,18.2386958 10.8972903,18.1144874 C10.8100124,17.9902677 10.6741705,17.9050021 10.5208583,17.8778121 C7.44800786,17.2949303 5.16590738,14.6400375 5.16590738,11.4735816 C5.16590738,8.87820764 6.73235001,6.64448879 8.99706177,5.60505968 L8.52956729,6.51649826 C8.46050392,6.65100686 8.44836096,6.80610458 8.49769249,6.9486968 C8.54626435,7.09055704 8.65175661,7.20889277 8.79063912,7.27578579 C8.92876584,7.34267317 9.08966694,7.35369782 9.23614026,7.30592246 C9.38337324,7.25888096 9.50480095,7.15671245 9.57387015,7.02220573 L10.7395949,4.76421347 C10.8139701,4.62088365 10.8215609,4.4540406 10.7616038,4.30482494 C10.7016486,4.15561493 10.5786996,4.03873937 10.4238739,3.98215785 L7.89813693,3.04132774 C7.82679652,3.01339637 7.75014429,2.99943069 7.67350177,3.00001777 L7.67323754,3.00001777 Z M13.6022779,4.00040469 C13.2935779,3.98938931 13.0295423,4.21484652 13.0022904,4.51376031 C12.975054,4.81265529 13.1937084,5.07998375 13.4993714,5.12258634 C16.5627419,5.70497847 18.8378019,8.36346681 18.8378019,11.526512 C18.8378019,14.1219613 17.2724149,16.3530512 15.0124626,17.3901029 L15.4845773,16.4794302 L15.4845773,16.4801653 C15.582934,16.3002361 15.5746112,16.0828481 15.461879,15.9110089 C15.3483894,15.7398916 15.149402,15.6407475 14.9398315,15.6517648 C14.7257094,15.6620451 14.5350622,15.7861604 14.4435059,15.9749128 L13.2813775,18.2310078 C13.2095018,18.3734821 13.2026917,18.5387204 13.2624619,18.6863442 C13.322234,18.833968 13.4432871,18.9499877 13.5961283,19.0065405 L16.1140732,19.9465793 C16.2608519,20.0134105 16.4288163,20.0178174 16.5786146,19.9583298 C16.7284207,19.8995773 16.8464465,19.7828075 16.9039525,19.6359338 C16.9614584,19.4890601 16.9531318,19.3260216 16.8812542,19.1857488 C16.8093784,19.0447437 16.6807483,18.9397224 16.5256622,18.8949202 L15.3817018,18.4660365 C18.1047623,17.2711522 20,14.6103701 20,11.5266643 C20,7.83700892 17.3292372,4.69896691 13.7171466,4.01217399 C13.6793173,4.0048304 13.6407308,4.00042349 13.6021443,4.00042349 L13.6022779,4.00040469 Z"/>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import {WebCam} from 'vue-web-cam';
import {Utils} from "@bvm/core";

export default {
  components: {WebCam},
  data() {
    return {
      videoLive: false,
      currentDeviceId: null,
      availableCameras: []
    };
  },
  methods: {
    show() {
      this.videoLive = true;
    },
    cameraChanged(deviceId) {
      this.currentDeviceId = deviceId;
    },
    cameraListLoaded(availableCameras) {
      this.availableCameras = availableCameras;
    },
    changeCamera(deviceId) {
      this.$refs.webCam.changeCamera(deviceId);
    },
    selectNextCamera() {
      let nextIndex = this.availableCameras.findIndex(camera => camera.deviceId === this.currentDeviceId) + 1;
      nextIndex = nextIndex < this.availableCameras.length ? nextIndex : 0;
      this.changeCamera(this.availableCameras[nextIndex].deviceId);
    },
    capture() {
      Utils.Event.EventBus.$emit('webCamPhotoCaptured', this.$refs.webCam.capture());
      this.close();
    },
    close() {
      this.$emit('dismissModal');
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@bvm/style/src/assets/scss/base/base";

.modal.modal__phototaking {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  display: flex !important;
  justify-content: center;
  align-content: center;
  align-items: center;
  max-height: 100vh;
  overflow: hidden;
}

.modal__phototaking .modal-content .modal-header button.close {
  display: none;
}

.modal.show.modal__phototaking {
  opacity: 1;
  visibility: visible;

  .modal-dialog {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: 100%;
    margin: 0;
  }

  .modal-content {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: 100%;
    background: transparent;

    .modal-body {
      position: relative;
      max-height: 100%;
      padding: 0;
      width: auto;
      height: 100%;
    }

    .modal-header {
      position: relative;
      background: transparent;
      height: 0;
      padding: 0;
      border: 0 solid $color-white;
      width: 100%;

      button.close {
        right: 30px;
        top: 30px;
        position: absolute;
        border: 1px solid $color-tertiary;
        background: $color-white;
        border-radius: 50%;
        z-index: 10;
        width: 30px;
        height: 30px;
        padding: 0;
        display: flex;
        flex-direction: row;
        align-content: center;
        align-items: center;
        justify-content: center;

        i {
          display: flex;
          flex-direction: row;
          align-content: center;
          align-items: center;
          color: $color-tertiary;
          padding: 0;

          &:before {
            font-size: rem-calc(14);
          }
        }
      }
    }
  }

  .modal-dialog .modal-content .modal-body video {
    width: auto;
    height: 100vh;
    max-width: 100%;
    max-height: 100vh;
    display: flex;
    padding: 0;
  }

  .take-picture {
    position: absolute;
    bottom: 30px;
    left: 50%;
    margin-left: -25px;
    width: 50px;
    height: 50px;
    border: 2px solid $color-white;
    border-radius: 50%;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;

    &__inner-circle {
      width: 100%;
      height: 100%;
      background: $color-white;
      border-radius: 50%;
      display: block;
    }
  }

  .switch-camera {
    position: absolute;
    bottom: 37px;
    right: 25%;
    margin-right: -18px;
    border: 1px solid $color-primary;
    background: $color-white;
    border-radius: 50%;
    width: 37px;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 20px;
    }
  }
}
</style>
